export enum OffersType {
	DAYTRIP = 'DAYTRIP',
	ACCOMMODATION = 'ACCOMODATION',
	ORGANIZED_HOLIDAY = 'ORGANIZED_HOLIDAY',
}
